/**
 * Holds a reference to the OIDC logout function so it can be called from
 * outside React (e.g. axios interceptors), and revokes the current session
 * before clearing local state.
 */
let _logout: (() => Promise<void>) | null = null;
let _sessionID: string | null = null;

const authBase = process.env.REACT_APP_OAUTH2_AUTHORITY;

export function registerLogout(fn: () => Promise<void>) {
  _logout = fn;
}

export function registerSessionID(sessionID: string | undefined) {
  _sessionID = sessionID ?? null;
}

async function revokeCurrentSession(): Promise<void> {
  if (!_sessionID) return;
  try {
    const body = new URLSearchParams();
    body.set("session_id", _sessionID);
    await fetch(`${authBase}/oauth/revoke-session`, {method: "POST", body});
  } catch {
    // best-effort — don't block logout
  }
}

export async function triggerLogout() {
  await revokeCurrentSession();
  _logout?.();
}
